import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Hourglass } from "react-loader-spinner";
import api from "../../../api";

const AllTopic = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const [topics, setTopics] = useState([]);
  const [filteredTopics, setFilteredTopics] = useState([]);
  const [subjectFilter, setSubjectFilter] = useState(
    localStorage.getItem("topic-subject") || ""
  );
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const getTopics = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/topic/all`)
      .then((res) => {
        setTopics(res.data);
        setFilteredTopics(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    let filtered = [...topics];

    if (subjectFilter) {
      filtered = filtered.filter(
        (t) => t.subject === subjectFilter
      );
    }

    setFilteredTopics(filtered);
  }, [subjectFilter, topics]);

  useEffect(() => {
    getTopics();
  }, []);

  const handleSubjectChange = (e) => {
    localStorage.setItem("topic-subject", e.target.value);
    setSubjectFilter(e.target.value);
  };

  const deleteTopic = (id) => {
    swal({
      title: "Are you sure?",
      text: "This topic will be deleted permanently!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setDeleting(true);

        api
          .post(`${baseUrl}/topic/delete?id=${id}`)
          .then(() => {
            swal("Topic deleted!", { icon: "success" });
            getTopics();
            setDeleting(false);
          })
          .catch((err) => {
            swal(err?.response?.data?.message || "Something went wrong", { icon: "error" });
            setDeleting(false);
          });
      }
    });
  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? "" : styles.sidebarClosed}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? styles.open : styles.closed}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        {deleting && (
          <div className="loading-overlay">
            <Hourglass visible={true} height="80" width="80" />
          </div>
        )}

        <div style={{ height: "30px" }} className="position-relative">
          {isSidebarOpen ? (
            <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />
          ) : (
            <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />
          )}
        </div>

        {/* Breadcrumb */}
        <nav>
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to="/admin/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">All Topics</li>
              <li className="breadcrumb-item">
                <Link to="/admin/topic/create">Create</Link>
              </li>
            </div>

            <li className="nav-item dropdown">
              <span className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                Welcome, {user.name}
              </span>
              <ul className="dropdown-menu">
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>

        <div className="container-fluid bg-white p-4">
          <h4 className="mb-4">All Topics</h4>

          {/* 🔍 Filter */}
          <div className="mb-3">
            <label className="form-label">Filter by Subject</label>
            <select
              className="form-select"
              value={subjectFilter}
              onChange={handleSubjectChange}
            >
              <option value="">All</option>
              <option>Physics</option>
              <option>Chemistry</option>
              <option>Biology</option>
            </select>
          </div>

          {/* 📋 Table */}
          <div style={{ overflowX: "auto" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Topic Name</th>
                  <th>Subject</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="4">Loading...</td>
                  </tr>
                )}

                {!loading && filteredTopics.length < 1 && (
                  <tr>
                    <td colSpan="4">No topics found</td>
                  </tr>
                )}

                {filteredTopics.map((t, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{t.topicName}</td>
                    <td>{t.subject}</td>
                    <td>
                      <button
                        onClick={() => deleteTopic(t._id)}
                        className="btn btn-danger btn-sm"
                      >
                        <DeleteOutlineIcon fontSize="small" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllTopic;
